import { CommentAsyncStatus, IComment } from '@shared/models/comment.model';
import { useEffect, useState } from 'react';

const getAbstractStatus = (
  createdAt: Date,
  status: CommentAsyncStatus,
  assumeFailedThresholdMs: number,
): CommentAsyncStatus => {
  const elapsedTime = Math.abs(Date.now() - createdAt.getTime());
  const assumeFailed = elapsedTime > assumeFailedThresholdMs;
  switch (status) {
    case CommentAsyncStatus.Pending:
      return assumeFailed ? CommentAsyncStatus.Error : status;
    case CommentAsyncStatus.Error:
    case CommentAsyncStatus.Resolved:
      return status;
  }
};

export const useAbstractCommentAsyncStatus = (
  comment: IComment,
  assumeFailedThresholdMs: number,
) => {
  const [abstractStatus, setAbstractStatus] = useState(() =>
    getAbstractStatus(
      new Date(comment.created_at),
      comment.async_status,
      assumeFailedThresholdMs,
    ),
  );
  useEffect(() => {
    if (comment.async_status !== CommentAsyncStatus.Pending) {
      setAbstractStatus(comment.async_status);
      return; // If the abstract status is not pending or error, we don't need to check again
    }
    const createdAt = new Date(comment.created_at);
    const interval = setInterval(
      () =>
        setAbstractStatus(
          getAbstractStatus(
            createdAt,
            comment.async_status,
            assumeFailedThresholdMs,
          ),
        ),
      1000,
    );
    return () => clearInterval(interval);
  }, [comment.async_status, comment.created_at, assumeFailedThresholdMs]);

  return abstractStatus;
};
